module.exports = __webpack_public_path__ + "static/media/play icon.66020f3d.svg";